import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
interface SectionRevealProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function SectionReveal({
  children,
  className,
  id,
  delay = 0
}: SectionRevealProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: [0.21, 0.47, 0.32, 0.98],
    delay
  }} className={cn('py-16 md:py-24', className)} data-id="element-354" data-mp="378t74n4mc9ug">
      {children}
    </motion.section>;
}